import { BlockHeading } from "components/landing-pages/BlockHeading";
import { ThreeCardBlock } from "dtos/content/landing-pages/ThreeCardBlock";

export const ThreeCardBlockDisplay = (props: { block: ThreeCardBlock }) => {
    const { block } = props;
    const { items, heading } = block;

    return (
        <div className="grid">
            {heading && (
                <div className="g-col-12">
                    <BlockHeading block={block} />
                </div>
            )}

            {items.map(card => {
                const { heading, imageUrl, content, actionText, actionUrl, actionNewTab } = card;

                return (
                    <div key={heading} className="g-col-12 g-col-lg-4">
                        <div className="card h-100 position-relative">
                            <div className="card-img-top">
                                <img className="img-fluid" src={imageUrl} alt={heading} />
                            </div>

                            <div className="card-body">
                                <div className="vstack gap-3 h-100 justify-content-between">
                                    <div className="h5 text-center text-secondary">{heading}</div>

                                    <div
                                        className="text-center content-block vstack gap-3"
                                        dangerouslySetInnerHTML={{ __html: content }}
                                    ></div>

                                    {actionText && actionUrl && (
                                        <div className="text-center">
                                            <a
                                                className="btn btn-primary stretched-link stretched-link-hover"
                                                href={actionUrl}
                                                target={actionNewTab ? "_blank" : "_self"}
                                            >
                                                {actionText}
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
